import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  SxProps,
  Theme,
} from '@mui/material';
import React from 'react';
import routeConstants, { Route } from '../shared/constants/Routes';
import { Link, useLocation } from 'react-router-dom';
import useVirtualVotingPhase from '../hooks/useVirtualVotingPhase';

const Menus = [
  routeConstants.HOME,
  routeConstants.GOVERNANCE,
  // routeConstants.STAKER,
  // routeConstants.CONTRIBUTION,
  // routeConstants.VALIDATOR,
  // routeConstants.BUILDER,
];

const BottomNavStyle: SxProps<Theme> = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  height: '75px',
  display: {
    xs: 'block',
    md: 'none',
  },
  zIndex: 10,
};

const NavItemStyle: SxProps<Theme> = {
  display: 'flex',
  gap: '.5rem',
  color: '#404040',
  fontWeight: 700,
  '& .MuiBottomNavigationAction-label': {
    display: 'none',
  },
  minWidth: '10px',
};

const BottomNav = () => {
  const { hasVirtualOnVotingPhase } = useVirtualVotingPhase();

  const renderMenu = () => {
    return (
      <>
        {Menus.map((menu, index) => (
          <>
            <NavItem key={index} {...menu} />
            {menu.title === 'Governance Forum' && hasVirtualOnVotingPhase && (
              <span
                style={{
                  position: 'absolute',
                  top: '15px', // Adjust as needed for proper positioning
                  right: '5%', // Adjust as needed for proper positioning
                  width: '7px',
                  height: '7px',
                  borderRadius: '50%',
                  backgroundColor: 'red',
                }}
              ></span>
            )}
          </>
        ))}
      </>
    );
  };

  return (
    <Paper sx={BottomNavStyle}>
      <BottomNavigation showLabels={false}>{renderMenu()}</BottomNavigation>
    </Paper>
  );
};

const NavItem: React.FC<Route> = (props) => {
  const { pathname } = useLocation();
  return (
    <BottomNavigationAction
      component={Link}
      to={props.path}
      value={props.path}
      icon={props.icon}
      sx={{
        ...NavItemStyle,
        background: props.path === pathname ? '#F0FCFE' : undefined,
        color: props.path === pathname ? '#1D818F' : '#404040',
      }}
    />
  );
};

export default BottomNav;
